import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'not_substantiated_rejected'

export const dataPointDefinition = {
  retracedId: 'not_substantiated_rejected',
  name: 'Not substantiated / Rejected',
  description: 'This item refers to complaints that have been investigated and have been rejected / not substantiated.',
  meta: {
    slcpMeta: {
      key: 'wi-gri-36',
      number: 'WI-GRI-27',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-36', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36820,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
